import {Box, Grid, GridItem, HStack, Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {importPricingGrid} from '../constants/importPricingGrid';
import {IMPORT_VEHICLE_NR_COLUMN_WIDTH} from '../constants/importVehicleNrColumnWidth';

export function ImportPricingTableHeader(props: TestIdProps) {
  return (
    <Box
      backgroundColor="palettes.neutral.10.100"
      borderBottom="1px solid"
      borderColor="palettes.neutral.30.100"
      paddingVertical={2}
      paddingHorizontal={4}
      data-testid={suffixTestId('tableHeader', props)}
    >
      <Grid
        columns={importPricingGrid.columns}
        horizontalSpacing={4}
        verticalSpacing={0}
        align="center"
      >
        <GridItem span={importPricingGrid.specificationSpan}>
          <HStack spacing={4} align="center">
            <Box flexShrink={0} width={IMPORT_VEHICLE_NR_COLUMN_WIDTH}>
              <Text size="xSmall" color="secondary" alternative>
                {i18n.t('page.import.labels.rowNumber')}
              </Text>
            </Box>
            <Text size="xSmall" color="secondary" alternative>
              {i18n.t('page.import.labels.specification')}
            </Text>
          </HStack>
        </GridItem>
        <GridItem span={importPricingGrid.cellSpan}>
          <Text size="xSmall" color="secondary" alternative align="right">
            {i18n.t('page.import.pricing.pricingStatusColumn')}
          </Text>
        </GridItem>
        <GridItem span={importPricingGrid.cellSpan}>
          <Text size="xSmall" color="secondary" alternative align="right">
            {i18n.t('page.import.pricing.recommendedPrice')}
          </Text>
        </GridItem>
        <GridItem span={importPricingGrid.cellSpan}>
          <Text size="xSmall" color="secondary" alternative align="right">
            {i18n.t('page.import.pricing.openPriceReport')}
          </Text>
        </GridItem>
      </Grid>
    </Box>
  );
}
